module.exports = __webpack_public_path__ + "static/media/25_B.e84d0d6c.png";